<div class="cdn-container">

    <!-- Header -->
    <div class="cdn-header">
        <span class="cdn-title">Internal notes</span>
        <button class="cdn-add-btn" type="button" (click)="addNoteClicked.emit()">
            <i class="fa-solid fa-plus"></i> Add note
        </button>
    </div>

    <!-- Note cards -->
    @if (customerNotesList().length > 0) {
    <div class="cdn-list">
        @for (note of customerNotesList(); track note.id) {
        <div class="cdn-note">
            <div class="cdn-note-top">
                <div class="cdn-note-left">
                    <div class="cdn-avatar">{{ getInitials(note.employeeName) }}</div>
                    <div class="cdn-employee-info">
                        <div class="cdn-employee-main">
                            <span class="cdn-employee-name">{{ note.employeeName }}</span>
                            <span class="cdn-employee-sep">·</span>
                            <span class="cdn-employee-email">{{ note.employeeEmail }}</span>
                        </div>
                        <span class="cdn-date cdn-date--mobile">{{ note.createdAt | date:'dd/MM/yyyy, hh:mm a' }}</span>
                    </div>
                </div>
                <div class="cdn-note-right">
                    <span class="cdn-date cdn-date--desktop">{{ note.createdAt | date:'dd/MM/yyyy, hh:mm a' }}</span>
                    <div class="cdn-menu-wrap">
                        <button class="cdn-menu-btn" type="button" (click)="toggleMenu($event, note)">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        @if (activeMenuNoteId === note.id) {
                        <div class="cdn-menu-dropdown">
                            <button class="cdn-menu-item" type="button" (click)="openUpdateCustomerNoteForm(note)">
                                <i class="fa-regular fa-pen-to-square"></i> Edit
                            </button>
                            <button class="cdn-menu-item cdn-menu-item--danger" type="button" (click)="openDeleteCustomerNoteForm(note)">
                                <i class="fa-regular fa-trash-can"></i> Delete
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="cdn-note-text">{{ note.note }}</div>
            <app-note-photos class="cdn-note-photos" [photos]="note.photos" />
        </div>
        }
    </div>
    } @else {
    <div class="cdn-empty">No notes available</div>
    }

    <!-- Footer pagination -->
    @if (totalRecords() > 0) {
    <div class="cdn-footer">
        <span class="cdn-count">Showing {{ customerNotesList().length }} of {{ totalRecords() }}</span>
        <p-paginator
            [first]="first"
            [rows]="rows"
            [totalRecords]="totalRecords()"
            [rowsPerPageOptions]="[20, 30, 50]"
            [dropdownAppendTo]="'body'"
            (onPageChange)="onPageChange($event)" />
    </div>
    }

</div>

@defer (when updateCustomerNoteDialog; prefetch on idle) {
<app-update-customer-note-form (updatedCustomerNote)="onCustomerNoteUpdated()" [selectedCustomerNote]="selectedCustomerNote" [(visibility)]="updateCustomerNoteDialog" />
}

@defer (when deleteCustomerNoteDialog; prefetch on idle) {
<app-delete-customer-note-form (deletedCustomerNote)="onCustomerNoteDeleted()" [selectedCustomerNote]="selectedCustomerNote" [(visibility)]="deleteCustomerNoteDialog" />
}
